<!-- =========================================================================================
    File Name: tableFilterSorter.vue
    Description: Add filter and sorting functionality to table
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div>
    <b-overlay
      :show="show"
      :variant="variant"
      :opacity="opacity"
      :blur="blur"
      rounded="lg"
      spinner-variant="primary"
    >
      <b-card>
        <h4 class="heading">
          {{ $t("Recordings") }}
        </h4>

        <div class="export-table">
          <b-col lg="5" class="my-1 p-2 float-right">
            <b-form-group
              label-for="filter-input"
              label-cols-sm="3"
              label-align-sm="right"
              label-size="sm"
              class="mb-0"
            >
              <b-input-group size="md">
                <b-input-group-prepend is-text>
                  <b-icon icon="search"></b-icon>
                </b-input-group-prepend>
                <b-form-input
                  id="filter-input"
                  v-model="filter"
                  type="search"
                  :placeholder="$t('Search')"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-table
            :current-page="currentPage"
            :per-page="perPage"
            :items="staffs"
            :fields="fields"
            :busy="isBusy"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            responsive
            show-empty
            :filter="filter"
            :filter-included-fields="filterOn"
            :empty-text="$t('EmptyData')"
            :empty-filtered-text="$t('EmptyFilter')"
            @filtered="onFiltered"
          >
            <template #head()="data">
              <span>{{ $t(data.label) }}</span>
            </template>
            <!-- rows -->

            <template #cell(appointment_id)="data">
              <a
                :href="'/company/appointment/show/' + data.value"
                target="_blank"
                >{{ data.value }}</a
              >
            </template>
            <!-- A custom formatted column -->
            <template #cell(actions)="row">
              <feather-icon
                v-b-tooltip.hover
                :title="$t('Delete')"
                icon="TrashIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-2"
                @click="deleteRecording(row.item.file_link.file)"
              />

              <a :id="indextr" @click="downloadFiles(row.item)">
                <feather-icon
                  v-b-tooltip.hover
                  :title="$t('DownloadRecording')"
                  icon="DownloadIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-2"
                />
              </a>
            </template>
          </b-table>

          <b-pagination
            v-if="rows > perPage"
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            aria-controls="my-table"
            class="float-right"
          ></b-pagination>
        </div>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import moment from "moment";
import $ from "jquery";
export default {
  data() {
    return {
      staffs: [],
      staff_id: "",
      perPage: 10,
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      isBusy: false,
      totalRows: 1,
      fields: [
        {
          key: "appointment_id",
          label: "AppointmentId",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "inmate_name",
          label: "InmateName",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "full_user_name",
          label: "Recording",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "appointment_date",
          label: "Date",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "appointment_start_time",
          label: "Time",
          sortable: true,
          sortDirection: "desc",
        },
        { key: "actions", label: "Action" },
      ],

      show: false,
      variant: "light",
      opacity: 0.85,
      blur: "2px",
      error: "",
      success: "",
    };
  },

  computed: {
    rows() {
      return this.staffs.length;
    },
  },

  created() {
    this.getRecordings();
  },

  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    /**
     *
     * getRecordings   method  for list all staffs data
     **/
    getRecordings() {
      this.success = "";
      this.error = "";
      this.show = true;

      this.$store
        .dispatch("GetRecordings", this.$store.getters.currentUser.id)
        .then((res) => {
          this.show = false;

          let staffs_res = res.data.data;

          this.staffs = staffs_res.map((element, index) => {
            element.appointment_start_time = moment(
              element.appointment_start_time,
              "h:mm a"
            ).format("LT");
            return element;
          });
          this.totalRows = this.staffs.length;  
        })
        .catch((error) => {
          this.$log.error(
            "File : List.vue | Function : getstaffs() | Error :",
            error
          );
          this.show = false;
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },
    /**
     *
     * deleteRecording   method  for delete  staff from listing
     **/
    deleteRecording(file) {
      this.$swal({
        title: this.$t("DeleteRecordingMessage"),

        type: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("Yes"),
        confirmButtonColor: "#7367F0",
        cancelButtonText: this.$t("No"),
        showCloseButton: true,
        showLoaderOnConfirm: true,
      })
        .then((result) => {
          if (result.value) {
            this.success = "";
            this.error = "";
            this.show = true;
            let data = { file_name: file };
            this.$store.dispatch("DeleteRecording", data).then((res) => {
              this.show = false;
              this.getRecordings();

              this.success = this.$t("RecordingDeleteSuccess");
              this.$toasted.show(this.success, {
                className: "top-alert",
                position: "top-center",
                type: "success",
                duration: 2000,
              });
            });
          }
        })
        .catch((error) => {
          this.$log.error(
            "File : List.vue | Function : deleteRecording() | Error :",
            error
          );
          this.show = false;
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },
    /**
     *
     * getRecordings   method  for list all staffs data
     **/
    downloadVideo(data) {
      this.success = "";
      this.error = "";
      this.show = true;
      this.$store
        .dispatch("DownloadFiles", data)
        .then((res) => {
          this.show = false;

     
          var fileURL = window.URL.createObjectURL(new Blob([res.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", atob(data.file_name));
          document.body.appendChild(fileLink);

          fileLink.click();
        })
        .catch((error) => {
          this.$log.error(
            "File : List.vue | Function : downloadVideo() | Error :",
            error
          );
          this.show = false;
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },
    /**
     *
     * download files
     **/
    downloadFiles(files) {
      var filesForDownload = [];
      for (let n = 0; n < files.transcription.length; n++) {
        let keys = Object.keys(files.transcription[0]);
        let values = Object.values(files.transcription[0]);

        var arr = keys.reduce(
          (obj, key, index) => ({ ...obj, [key]: values[index] }),
          {}
        );
        filesForDownload.push(arr);
      }
      let data = {
        file_name: btoa(files.file_link.file),
        company_id: this.$store.getters.currentUser.id,
      };
      this.downloadVideo(data);
      var temporaryDownloadLink = document.createElement("a");
      temporaryDownloadLink.style.display = "none";

      document.body.appendChild(temporaryDownloadLink);
      for (var n = 0; n < filesForDownload.length; n++) {
        var download = filesForDownload[n];
        temporaryDownloadLink.setAttribute("href", download.url);
        temporaryDownloadLink.setAttribute("download", download.file);
        temporaryDownloadLink.setAttribute("target", "_blank");
        temporaryDownloadLink.click();
      }

      document.body.removeChild(temporaryDownloadLink);
    },
  },
};
</script>

<style lang="stylus" scope>
.heading {
  margin-bottom: 20px;
}

.add {
  position: absolute;
  margin-top: 10px;
}

.action {
  margin-left: 20px;
  display: inline;
}

.con-vs-tooltip {
  display: inline;
}
</style>